import { CLValue, Key, KeyTypeID } from 'casper-js-sdk';
import { buildRouterPath } from '../router/utils';
import { DICTIONARY_PATH } from '../router/paths';
import { TransactorHashType } from '@block-explorer/entities';

export const getDictionaryPathByHash = (
  hash: string | null,
  uref: string | undefined,
  type: TransactorHashType
) => {
  const hashType =
    type === TransactorHashType.hash ? KeyTypeID.Hash : KeyTypeID.Account;

  const hashBytes = hash
    ? CLValue.newCLKey(Key.createByType(hash, hashType)).bytes()
    : null;

  const dictionarySearchKey = hashBytes
    ? Buffer.from(hashBytes as any).toString('base64')
    : null;

  const path =
    uref && dictionarySearchKey
      ? buildRouterPath(
          DICTIONARY_PATH,
          { id: uref },
          { dictionary_key: dictionarySearchKey }
        )
      : null;
  return path;
};
